import styles from './DisplayDateProvider.module.scss'
import moment from 'moment'
import getEpiWeek from '../../utils/getEpiWeek'
import { useGeoState } from '../GeoProvider'
export const DisplayDateProviderNew = ({textShow, showWeek, lastweekEndDate,dashType,statesData }) => {
  const {  displayDate, indicatorName } = useGeoState()
  // const lastweekEndWeek = moment(lastweekEndDate, 'yyyy-MM-DD').week()
  // TODO : this const number should be moved out at the /Flu level to be used also for the <DisplayDate /> component
  let epiweek=''
  if(statesData!==undefined && statesData!==null){
const keys = Object.keys(statesData).sort()
  const values = Object.values(statesData)
  const daysData = values.map((weeklyData, index) => {
    return { index, date: keys[index], ...weeklyData }
  })
   epiweek = (daysData.filter((w) => w.date === displayDate)[0].TX.epiweek!==undefined?daysData.filter((w) => w.date === displayDate)[0].TX.epiweek:'')
}
   return  (
    dashType==='VULNERABILITY' ||dashType==='BIRTHTREND'? <div className={styles.base}>
    <div className={styles.dateWeek}>
      <p className={styles.displayDateMargin}>
      {textShow} {indicatorName}
      {/* {showWeek ? ` ${textShow} ${getEpiWeek(lastweekEndDate)}: ` : null}
        {' '}{moment(lastweekEndDate).format('MMMM')}{' '} 
        1 - 31,{' '}
        {moment(lastweekEndDate).format('YYYY')} */}
        {' '}{moment(lastweekEndDate).format('MMMM')}{' '}
        
       {dashType==='BIRTHTREND'?'':moment(lastweekEndDate).startOf('month').format('D')+'- '+moment(lastweekEndDate).endOf('month').format('D')+', '} 
        {moment(lastweekEndDate).format('YYYY')}
       
      </p>
    </div>
  </div>:
     <div className={styles.base}>
     <div className={styles.dateWeek}>
       <p className={styles.displayDateMargin}>
       {/* {textShow} {lastweekEndDate} */}

       {showWeek ? ` ${textShow} ${epiweek}: ` : null}
         {moment(lastweekEndDate).format('MMMM D, YYYY')}{' '}
       
        
       </p>
     </div>
   </div>
  )
}

export default DisplayDateProviderNew
